import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const BusinessSolutionAPI = (props) => {
  return axios.get(
    `${env.HOST}/solusi-bisnis-anda${props}`,
    {
      headers
    }
  );
};
export default BusinessSolutionAPI;
